import * as THREE from "three";
import CustomObject from "./CustomObject.js";
import Experience from "../../Experience.js";
import { RectAreaLightHelper } from "three/examples/jsm/helpers/RectAreaLightHelper.js";

export default class Window extends CustomObject {
  constructor(modelPath, position, id, scale, rotation) {
    super(modelPath, position, id, rotation);
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.type = "window";
    this.scale = scale;

    this.collisionAllowed = true;
    this.snappingAllowed = true;
    this.axesMove = [true, true, true]; // x, y, z
    this.shadow = false;
    this.windowLight = this.createWindowLight(this.position, this.scale);
  }

  createWindowLight(position, scale) {
    const windowLight = new THREE.RectAreaLight(
      "#ffffff",
      1,
      scale.x - 0.1,
      scale.y - 0.1
    );

    /* windowLight.position.copy(position); */

    /* windowLight.position.y = position.y * 2; */
    /*     windowLight.position.z = 0 + 0.02;
     */ if (this.rotation.y) {
      if (this.rotation.y === -Math.PI / 2) {
        windowLight.intensity = 1.5;
      } else {
        windowLight.intensity = 0;
      }
    } else {
      windowLight.intensity = 0;
    }

    windowLight.rotation.y = Math.PI;

    /* windowLight.rotation.y = Math.PI; */

/*     const helper = new RectAreaLightHelper(windowLight);
    windowLight.add(helper); */
    /* group.add(new RectAreaLightHelper(spotLight)); */
    return windowLight;
  }
}
